import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Destinations from "./components/Destinations";
import WhyChooseUs from "./components/WhyChooseUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFAB from "./components/WhatsAppFAB";

const Landing = () => {
  return (
    <div className="relative min-h-screen bg-background text-foreground" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Destinations />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
